import { TrendingUp, Landmark, ScrollText, LineChart, Briefcase, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const products = [
  { icon: TrendingUp, title: "Mutual Funds", copy: "SIP or lumpsum, handpicked around your goals.", slug: "mutual-funds" },
  { icon: Landmark, title: "Fixed Deposits", copy: "Bank & corporate FDs for dependable stability.", slug: "fixed-deposits" },
  { icon: ScrollText, title: "Bonds & Debentures", copy: "Fixed-income securities for conservative growth.", slug: "bonds" },
  { icon: LineChart, title: "Stocks", copy: "Gold Bonds, Pre-IPO opportunities and F&O.", slug: "stocks" },
  { icon: Briefcase, title: "PMS / AIFs", copy: "For HNIs with a higher risk appetite.", slug: "pms-aif" },
  { icon: ShieldCheck, title: "Term & Health Insurance", copy: "Secure your family's future and protect savings.", slug: "insurance" },
];

export const Products = () => (
  <section id="products" data-testid="products-section" className="grain relative bg-wealth-dark py-28 md:py-36 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(103,37,244,0.1),transparent_50%)]" />
    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <Eyebrow index="03" label="Investment products" dark />
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-bone mt-5 max-w-3xl">
          One partner. <span className="italic text-brand-light">Every instrument</span> your wealth needs.
        </h2>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-bone/10 border border-bone/10">
        {products.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.05}>
            <div
              data-testid={`product-card-${p.slug}`}
              className="group h-full bg-wealth-dark p-10 min-h-[250px] flex flex-col justify-between transition-colors duration-500 hover:bg-wealth"
            >
              <p.icon size={30} strokeWidth={1.5} className="text-brand-light" />
              <div className="mt-12">
                <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight text-bone">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-bone/55">{p.copy}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 text-xs uppercase tracking-[0.2em] text-bone/40">
          All products managed on the Wealthy app — a SEBI-registered platform trusted by 1,00,000+ investors.
        </p>
      </Reveal>
    </div>
  </section>
);
